<template>
  <div>
    <el-form size="mini" ref="form" label-position="left" label-width="170px" v-loading="loading" element-loading-spinner="nucleus-loader">
      <el-row :gutter="30">
        <el-col :span="12">
          <h4 class="headerWithBorder">Chart Demographic</h4>

          <!-- <el-form-item size="mini" label="Patient Number">
            <el-input disabled size="mini" :maxlength="15" type="text" id="patientNumber" v-model="worksheet.patientNumber"> </el-input>
          </el-form-item> -->

          <el-form-item size="mini" label="Patient Number">
            <a v-if="documentManagerAdmin() && recordId && !readOnly" style="margin: 6px 0px 0px 0px; float: left;" :href="`${compParticleBaseUrl}/reviews/pro/${recordId}`" target="_new">{{ worksheet.patientNumber }}</a>
            <el-input v-else disabled size="mini" :maxlength="15" type="text" id="patientNumber" v-model="worksheet.patientNumber"> </el-input>
          </el-form-item>

          <el-form-item size="mini" label="MR Number">
            <el-input :disabled="disabled" size="mini" :maxlength="15" type="text" id="mrNumber" v-model="worksheet.mrnumber"> </el-input>
          </el-form-item>

          <el-form-item size="mini" label="Payor">
            <el-input :disabled="disabled" v-model="worksheet.payorName" placeholder="Payor" itemkey="key" label="value"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Payor Detail">
            <el-input :disabled="disabled" v-model="worksheet.payorDetail" placeholder="Payor Detail" itemkey="key" label="value"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Date of Service">
            <el-date-picker :disabled="disabled" size="mini" type="date" id="dischargeDate" v-model="worksheet.dateOfService" format="MM/dd/yyyy"> </el-date-picker>
          </el-form-item>

          <el-form-item size="mini" label="Age">
            <el-input disabled v-model="worksheet.patientAge"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Patient Sex">
            <el-input disabled v-model="worksheet.sex"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <h4 class="headerWithBorder">Review Information</h4>

          <el-form-item size="mini" label="Facility">
            <el-input disabled v-model="worksheet.clientName"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Auditor">
            <el-input disabled v-model="worksheet.reviewerName"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Review Date">
            <el-date-picker disabled size="mini" type="date" id="revDate" v-model="worksheet.reviewDate" format="MM/dd/yyyy"> </el-date-picker>
          </el-form-item>

          <el-form-item size="mini" label="Coder">
            <el-input disabled v-model="worksheet.coder"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Provider">
            <el-input disabled v-model="worksheet.physicianName"></el-input>
          </el-form-item>

          <!-- <el-form-item size="mini" label="Audit Result">
            <el-input disabled v-model="worksheet.auditResult"></el-input>
          </el-form-item> -->
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :xl="8" :sm="12" class="top-margin">
          <h4 class="headerWithBorder">Original Coding Details</h4>

          <el-form-item size="mini" label="Place of Service">
            <el-input disabled v-model="worksheet.placeOfService"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Patient Status">
            <el-input disabled size="mini" id="patientStatusDesc" v-model="worksheet.patientStatusDesc"> </el-input>
          </el-form-item>

          <el-form-item size="mini" label="EM Guidelines">
            <el-input :disabled="disabled" size="mini" id="originalWeight" v-model="worksheet.emGuidelines"></el-input>
          </el-form-item>
        </el-col>

        <!-- <el-col :xl="8" :sm="12" class="top-margin">
          <h4 class="headerWithBorder">Query Analysis</h4>

          <el-form-item size="mini" label="Coder Query">
            <el-input disabled :value="worksheet.coderQuery ? 'Yes' : 'No'"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Coder Query Missed">
            <el-input disabled :value="worksheet.coderQueryMissed ? 'Yes' : 'No'"></el-input>
          </el-form-item>

          <el-form-item size="mini" label="Reviewer Query">
            <el-input disabled :value="worksheet.auditQuery ? 'Yes' : 'No'"></el-input>
          </el-form-item>
        </el-col> -->
      </el-row>
    </el-form>
  </div>
</template>

<script>
import dateHelper from '@/mixins/date-helper'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import { format, parseISO } from 'date-fns'
import { mapMutations } from 'vuex'

export default {
  name: 'coderInpatientDemographics',
  mixins: [dateHelper, HiaAuthorization],
  props: {
    worksheet: { type: Object, required: true },
    readOnly: { type: Boolean, default: false }
  },
  data() {
    return {
      format: format,
      parseISO: parseISO,
      disabled: true,
      loading: false
    }
  },
  methods: {
    ...mapMutations('myProjects/', ['SET_RESPONSE_PATSTAT', 'SET_RESPONSE_DRG', 'SET_RESPONSE_POO'])
  },
  computed: {
    compParticleBaseUrl() {
      return process.env.VUE_APP_PARTICLE_BASE_URL
    },
    recordId() {
      return this.$route.params.proRecordId || this.worksheet.proRecordId
    }
    // ...mapState('profile/', ['userProfile'])
  }
}
</script>
